import { reactive } from 'vue';
import BasePagedListFilterService from '@/services/BasePagedListFilterService';
import { mapProperty } from '@/utils/tools';
import CompanyApiAgency from '@/api/CompanyApiAgency';

export class UnlockModuleOrderListFilterService extends BasePagedListFilterService<
  ICompanyWithOrderPluginPagedListParameters,
  ICompanyWithOrderPluginModel
> {
	protected get api () { return mapProperty(CompanyApiAgency, 'pluginOrderList', 'grid'); }

	get quickFilters () { return undefined; }

	protected filterComponent = undefined;

	filter = reactive<ICompanyWithOrderPluginPagedListParameters>({
		...this.commonFilter,
		research: undefined,
		showIsActivated: false,
	});
}

const UnlockModuleOrderListFilterServiceSingleton = new UnlockModuleOrderListFilterService();

export default function useUnlockModuleOrderListFilterService () {
	return UnlockModuleOrderListFilterServiceSingleton;
}
